var GlobalTitle = () => import('~/components/atoms/Editorial/Global/GlobalTitle.vue');
export default {
  name: 'TitleSection',
  components: {
    GlobalTitle
  },
  props: {
    title: {
      type: Object,
      required: true
    },
    textColor: {
      type: String,
      default: ''
    }
  }
};